import { memo } from 'react';
import cls from 'classnames';
import { useTranslation } from 'react-i18next';
import { SingleToolHeader } from '@quicktools/shared-components/components/common';
import { GoogleAd, useShowAd } from '@quicktools/shared-components/components/GoogleAd';
import {
  GOOGLE_AD_MANAGER_QT_LEADER_BOARD_MOBILE,
  GOOGLE_AD_MANAGER_QT_LEADER_BOARD_WEB,
} from '@quicktools/shared-components/services/constants';

import analytics from '../../services/analytics';

import useStyles from './styles';

function Header() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { showDesktopAd, showMobileAd } = useShowAd();

  return (
    <div className={cls(classes.root, 'header')}>
      {showMobileAd && <GoogleAd id={GOOGLE_AD_MANAGER_QT_LEADER_BOARD_MOBILE} />}

      {showDesktopAd && <GoogleAd id={GOOGLE_AD_MANAGER_QT_LEADER_BOARD_WEB} />}

      <SingleToolHeader toolName={t('toolName')} analytics={analytics} />
    </div>
  );
}

export default memo(Header);
